import React from 'react';
import { Link } from 'react-router-dom';
import './Pricing.css';

const Pricing = () => {
  return (
    <section id="pricings" className="py-20 bg-gradient-to-br from-orange-50 via-white to-orange-50 animate-on-scroll">
      <div className="container mx-auto text-center max-w-3xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-3 animate-on-scroll">
          Notre plateforme est <span className="gradient-highlight">gratuite</span>
        </h2>
        
        <div className="pricing-info animate-on-scroll">
          <p className="section-description">
            Pas d'abonnement, pas de frais cachés : vous ne payez que la livraison de chaque colis, que vous soyez un particulier ou un marchand.
          </p>
          
          <div className="pricing-highlight animate-on-scroll">
            <svg className="decorative-sparkle" width="32" height="12" viewBox="0 0 32 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 10.3846L9.66667 2" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
              <path d="M11.6667 10.3846L20.3333 2" stroke="white" strokeWidth="2.5" strokeLinecap="round" style={{ opacity: 0.6 }}/>
              <path d="M22.3333 10.3846L31 2" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
            <h4 className="pricing-highlight-title">Frais de Livraison</h4>
            <p className="pricing-highlight-text">
              Nos frais de livraison commencent à partir de <span className="price-value-highlight">500 FCFA</span>, et varient selon la destination et le poids de votre colis.
            </p>
            <div className="pricing-links">
              <a href="/get-quote"  className="pricing-link-button">Calculateur de prix</a>
              <a href="/contact" className="pricing-link-text">En savoir plus sur les frais</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
